import { savyTyyli } from '../lib/varit';

/**
 * Asiakaskoodi omanvärisellä taustallaan.
 *
 * Yksi komponentti eikä toistettu luokkajono: koodi näkyy kalenterissa,
 * kirjauslomakkeella, asiakasvalitsimessa ja tarkastelussa, ja niiden on
 * näytettävä samalta — muuten sävy ei ole tunniste vaan koriste.
 *
 * Väri on **taustassa**, teksti tavallista tekstiväriä. Siksi koodi on
 * luettavissa sävystä riippumatta eikä kontrasti ole värin varassa, ja
 * siksi sävy ei sekaannu tilaväreihin (laskutettavuus, huomautus,
 * budjetin ylitys), jotka ovat aina tekstin ja kuvakkeen värejä (15).
 *
 * `colorKey` on asiakkaan valittu sävy; ilman sitä sävy johdetaan
 * koodista. Kutsujan on annettava se aina kun se on saatavilla — muuten
 * sama asiakas näyttäisi eriväriseltä eri näkymissä, mikä on pahempi kuin
 * värien puuttuminen kokonaan.
 *
 * `luvut` antaa taulukkonumerot: koodeissa on numeroita, ja allekkaiset
 * koodit ovat listassa eri levyisiä ilman sitä.
 */
export default function AsiakasKoodi({
  code,
  colorKey,
  className = '',
}: {
  code: string;
  colorKey?: string | null;
  className?: string;
}) {
  return (
    <span
      className={`asiakas-siru luvut rounded-sm px-1 py-px ${className}`.trimEnd()}
      style={savyTyyli(code, colorKey)}
    >
      {code}
    </span>
  );
}
